<template>
  <div class="container">
    <div v-if="vipCode == 1">
      <!-- 会员时间 -->
      <div class="content">
        <div class="myMbmber">
          <div class="member_div">
            <img class="member_div_img" :src="vipRights.headImg">
          </div>
          <div class="allHeadValidity">
            <div class="headValidity">
              <p class="vip_name">{{vipRights.nickname}}</p>
              <p class="vip_date">会员有效期：{{vipRights.time | formatDate}}</p>
            </div>
            <div class="renewal" @click="openVip()">续费</div>
          </div>
        </div>
        <div class="vip_interests">
          <img class="vip_interests_img" src="../assets/member/vip5.png">
          <div class="save_money">
            已为您节省
            <span class="save_money_span">¥{{vipRights.saveMoney | moneySwitch}}</span>
          </div>
        </div>
      </div>
      <!-- 优惠券 -->
      <div class="coupons" v-if="couponList && couponList.length>0">
        <img class="coupons_title_1" src="../assets/member/title_1.png">
        <ul class="coupons_ul">
          <li class="coupons_list" v-for="item in couponList" :key="item.id">
            <img class="coupons_list_img" src="../assets/member/vip6.png">
            <div class="coupons_list_div">
              <p class="coupons_list_div_p1">
                <span class="coupons_list_div_p1_span">¥</span>
                {{item.money}}
              </p>
              <p class="coupons_list_div_p2">满{{item.condition}}使用</p>
            </div>
          </li>
        </ul>
        <div
          class="key_get"
          :disabled="{disabled}"
          :style="{background:background}"
          @click="toReceive()"
        >{{oneKeyText}}</div>
      </div>
      <!-- 省钱列表 -->
      <div class="offer_list">
        <img class="offer_list_img" src="../assets/member/title_2.png">
        <goodsList v-if="vipCode == 1"/>
      </div>
    </div>
    <div class="member" v-else>
      <div calss="coordinates">
        <img src="../assets/member/hhd_vip_01.jpg" calss="vip_img">
        <div class="openVip">
          <img src="../assets/member/hhd_vip_02.jpg">
          <div class="openVipWin" @click="openVip()">
            <span class="preferential">
              限时特惠:
              <span class="years_money">¥ {{vipPriceList.vipPrice}}/{{vipPriceList.deadline}}年</span> 立即开通
            </span>
            <img src="../assets/member/vip_wkt_jump.png">
          </div>
        </div>
        <div class="full_discount">
          <img src="../assets/member/hhd_vip_03.jpg">
          <div class="tab" ref="tab">
            <ul class="tab_content" ref="tabWrapper">
              <li class="tab_item" ref="tabitem" v-for="item in itemTab" :key="item.title">
                <img :src="item.resource" class="tab_img">
              </li>
            </ul>
          </div>
        </div>
        <img src="../assets/member/hhd_vip_04.jpg">
        <img src="../assets/member/hhd_vip_05.jpg">
        <div class="addVip">
          <img src="../assets/member/hhd_vip_06.jpg">
          <img src="../assets/member/vip_btn.jpg" class="add_img" @click="openVip()">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable space-before-function-paren */
/* eslint-disable semi */
/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable handle-callback-err */
/* eslint-disable eqeqeq */
import {
  vipCouponList,
  addCouponBatch,
  vipRights,
  recommendImg,
  findVipPriceList
} from "@/request/api";
import { formatDate, moneySwitch, getUrlKey } from "@/util/util";
import BScroll from "better-scroll";
import goodsList from "@/components/goodsList.vue";
export default {
  components: { goodsList },
  data() {
    return {
      vipRights: [], // 会员信息及优惠
      couponList: [], // 会员优惠商品
      itemTab: [],
      vipPriceList: [],
      disabled: false,
      oneKeyText: "一键领取",
      vipCode: null,
      background:
        "linear-gradient(270deg,rgba(216,172,57,1) 0%,rgba(255,228,158,1) 100%)"
    };
  },
  created() {
    this.vipCode = getUrlKey("vipCode");
    if (this.vipCode == 1) {
      // 会员
      this.getVipRights();
      this.getVipCouponList();
    } else {
      // 非会员
      this.getRecommendImg();
      this.getFindVipPriceList();
    }
  },
  filters: {
    formatDate(time) {
      var date = new Date(time * 1000);
      return formatDate(date, "yyyy.MM.dd");
    },
    moneySwitch(money) {
      return moneySwitch(money);
    }
  },
  methods: {
    personScroll() {
      let width = 0;
      for (let i = 0; i < this.itemTab.length; i++) {
        width += this.$refs.tabitem[0].getBoundingClientRect().width; // getBoundingClientRect() 返回元素的大小及其相对于视口的位置
      }
      // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
      this.$refs.tabWrapper.style.width = width + "px";
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.tab, {
            startX: 0,
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: "vertical"
          });
        } else {
          this.scroll.refresh();
        }
      });
    },
    // 会员信息
    getVipRights() {
      vipRights({})
        .then(res => {
          this.vipRights = res.result;
        })
        .catch(err => {
          this.$toast.center("请求错误会员信息");
        });
    },
    // 非会员页面的商品图片
    getRecommendImg() {
      recommendImg({})
        .then(res => {
          this.itemTab = res.result;
          this.$nextTick(() => {
            this.personScroll();
          });
        })
        .catch(err => {
          this.$toast.center("请求错误非会员页面的商品图片");
        });
    },
    // 开通会员以及续费接口
    getFindVipPriceList() {
      findVipPriceList({})
        .then(res => {
          this.vipPriceList = res.result.priceList[0];
        })
        .catch(err => {
          this.$toast.center("请求错误开通会员以及续费接口");
        });
    },
    // 会员优惠券
    getVipCouponList() {
      vipCouponList({})
        .then(res => {
          this.couponList = res.result ? res.result : [];
          let filterCoupon = this.couponList.filter(item => {
            return item.status == 0 ? true : false;
          });
          if (filterCoupon.length > 0) {
            this.disabled = true; // 按钮不可用
            this.oneKeyText = "已领取";
            this.background = "#ddd";
          } else {
            this.disabled = false; // 按钮可用
            this.oneKeyText = "一键领取";
            this.background =
              "linear-gradient(270deg,rgba(216,172,57,1) 0%,rgba(255,228,158,1) 100%)";
          }
        })
        .catch(err => {
          this.$toast.center("请求错误会员优惠券");
        });
    },
    // 一键领取优惠券
    toReceive() {
      let that = this;
      let couponArr = [];
      for (const key in that.couponList) {
        couponArr.push(that.couponList[key].id);
      }
      addCouponBatch({
        couponIds: couponArr
      })
        .then(res => {
          if (res.code == 0) {
            console.log(res);
            this.$toast.center(res.result);
            that.getVipCouponList();
          }
        })
        .catch(err => {
          this.$toast.center("请求错误一键领取优惠券");
        });
    },
    // 开通会员
    openVip() {
      let ua = navigator.userAgent.toLowerCase();
      // Android终端
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      // Ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        window.webkit.messageHandlers.openMember.postMessage({});
      } else if (/(Android)/i.test(navigator.userAgent)) {
        $App.openMember(this.vipCode); // vue给android传值
      }
    }
  }
};
</script>
  <style lang="scss" scoped>
@import "../assets/css/function.scss";
.container {
  font-size: 0;
  // position: fixed;
  width: 100%;
  height: 100%;
  // overflow: hidden;
  background: #f9f9f9;
  .content {
    padding: px2rem(21px) px2rem(32px);
    padding-top: px2rem(74px);
    background: linear-gradient(
      0deg,
      rgba(58, 58, 58, 1) 0%,
      rgba(42, 42, 42, 1) 100%
    );

    .myMbmber {
      display: flex;
      font-size: px2rem(34px);
      margin-bottom: px2rem(15px);
      .member_div {
        margin-right: px2rem(15px);
        .member_div_img {
          width: px2rem(99px);
          height: px2rem(99px);
          border-radius: 50%;
          margin-right: px2rem(12px);
        }
      }
      .allHeadValidity {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      .headValidity {
        .vip_name {
          font-size: px2rem(38px);
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
        }
        .vip_date {
          font-size: px2rem(20px);
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(255, 232, 173, 1);
          opacity: 0.7;
        }
      }
      .renewal {
        width: px2rem(120px);
        height: px2rem(44px);
        border: 1px solid rgba(255, 232, 173, 1);
        border-radius: px2rem(22px);
        text-align: center;
        font-size: px2rem(24px);
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 232, 173, 1);
        line-height: px2rem(44px);
        margin-top: px2rem(27px);
      }
    }
    .vip_interests {
      position: relative;
      font-weight: 400;
      .save_money {
        position: absolute;
        top: px2rem(38px);
        right: px2rem(22px);
        font-size: px2rem(30px);
        font-family: PingFangSC-Light;
        color: rgba(131, 120, 92, 1);
        .save_money_span {
          font-size: px2rem(48px);
          color: #ffe8ad;
          font-family: PingFangSC-Semibold;
        }
      }
      .vip_interests_img {
        width: 100%;
      }
    }
  }
  .coupons {
    height: px2rem(480px);
    background: rgba(249, 249, 249, 1);
    box-shadow: 0px px2rem(8px) px2rem(30px) 0px rgba(69, 30, 18, 0.15);
    border-radius: px2rem(20px);
    margin: px2rem(41px) px2rem(32px);
    .coupons_title_1 {
      width: 100%;
      height: px2rem(33px);
      margin: px2rem(20px) 0;
    }
    .coupons_ul {
      height: px2rem(258px);
      .coupons_list {
        position: relative;
        float: left;
        margin: px2rem(20px) 0 0 px2rem(23px);
        .coupons_list_img {
          height: px2rem(120px);
        }
        .coupons_list_div {
          position: absolute;
          top: px2rem(0px);
          left: px2rem(0px);
          text-align: center;
          width: px2rem(200px);
          font-family: PingFangSC-Regular;
          font-weight: 400;
          .coupons_list_div_p1 {
            color: rgba(216, 172, 57, 1);
            line-height: px2rem(95px);
            font-size: px2rem(48px);
            .coupons_list_div_p1_span {
              font-size: px2rem(30px);
            }
          }
          .coupons_list_div_p2 {
            font-size: px2rem(18px);
            line-height: 0;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
    }
    .key_get {
      height: px2rem(80px);
      border-radius: px2rem(40px);
      margin: px2rem(30px) px2rem(233px);
      font-size: px2rem(30px);
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      line-height: px2rem(80px);
    }
  }
  .offer_list {
    width: 92%;
    margin: 0 auto;
    overflow: hidden;
    .offer_list_img {
      width: 100%;
      height: px2rem(33px);
      margin-top: px2rem(20px);
    }
  }
}
.member {
  font-size: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  img {
    width: 100%;
  }
  .openVip {
    position: relative;
    .openVipWin {
      height: px2rem(98px);
      background: linear-gradient(
        0deg,
        rgba(193, 153, 49, 1) 0%,
        rgba(234, 205, 130, 1) 100%
      );
      position: absolute;
      left: 0px;
      right: 0px;
      line-height: px2rem(98px);
      margin: 0 px2rem(63px);
      border-radius: 45px;
      text-align: center;
      bottom: 0px;
      font-size: px2rem(34px);
      img {
        width: px2rem(34px);
        height: px2rem(30px);
      }
      .preferential {
        font-family: PingFangSC-Light;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
      }
      .years_money {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .full_discount {
    position: relative;
    .tab {
      position: absolute;
      width: 100vw;
      overflow: hidden;
      bottom: 0;
      .tab_content {
        display: flex;
        .tab_item {
          flex: 0 0 px2rem(10px);
          .tab_img {
            width: px2rem(230px);
            height: px2rem(298px);
            margin-left: px2rem(30px);
            border-radius: px2rem(14px);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vipMember.vue